import { Observable } from "rxjs";

import {
    ITCIApplication,
    ITCIApplicationDeleteRequest,
    ITCIApplicationCreateRequest,
    TCITenantAppType
} from "@tci/common";

export class NgMockAppListService {

    constructor() { }

    // public getApps(): Observable<ITCIApplication[]> { // The array object do not include "info"
    //     return this.http.get(SERVICE_URLS.APPS)
    //         .map((response: Response) => response.json());
    // }

    // public getAppById(appId: string, appType?: TCI_APPLICATION_TYPE): Observable<ITCIApplication> {
    //     const queryParam = appType ? `?${QUERY_PARAMS.APP_TYPE}=${appType}` : "";
    //     return this.http.get(`${SERVICE_URLS.APPS}/${appId}${queryParam}`)
    //         .map((response: Response) => response.json());
    // }

    public postApp(appInfo: ITCIApplicationCreateRequest): Observable<any> {
        return Observable.of({
            "appId": "dqxgnabwfqr326koyxx6oniatf6do3tv",
            "name": "New_Mock_App_2",
            "msg": "Request to create the application 'New_Mock_App_2' has been accepted.",
            "success": true
         });
    }

    // public deleteApp(body: ITCIApplicationDeleteRequest) {
    //     const options = {
    //         headers: new Headers({ "Content-Type": "application/json" }),
    //         body
    //     };
    //     return this.http.delete(SERVICE_URLS.APPS + "/" + body.appId, options)
    //         .map((response: Response) => response.json());
    // }
}
